module.exports = __webpack_public_path__ + "img/opencv.9376c039.png";